import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { timer } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { UserService } from '../../core/services/data/user.service';
import { PromoCodeService } from '../../core/services/data/promo-code.service';

const ctaButtonText = {
	gold: 'Upgrade to Platinum',
	platinum: 'View Benefit List',
};

const ctaText = {
	gold: 'Promo limit too close for comfort? You can easily upgrade to a Platinum Membership at any time to continue receiving 10% off your promos.',
	platinum: 'Make sure you’re getting the most out of your Platinum'
	+ ' Membership by perusing this nifty list of all the benefits currently available to you!',
};

@Component({
	selector: 'app-member-benefit',
	templateUrl: './member-benefit.component.html',
	styleUrls: ['./member-benefit.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class MemberBenefitComponent implements OnInit {
	@Input() public orderPaymentAmount = 0;

	@Input() public hasEvent = false;

	public user: any;

	public ctaButtonText = '';

	public ctaText = '';

	public total;

	public available;

	public ready = false;

	public promoCode;

	public currentLimit;

	constructor(
		public userService: UserService,
		public promoCodeService: PromoCodeService,
	) {
	}

	ngOnInit(): void {
		this.userService.fetchUser(true).then((data: any) => {
			this.user = data;
			this.ctaButtonText = ctaButtonText[this.role];
			this.ctaText = ctaText[this.role];
			this.getPromoCodeDetails();
		}).catch(() => {});
	}

	get roleName() {
		return this.userService.me?.memberRole?.roleName;
	}

	get role() {
		if (!this.roleName) return null;

		return this.roleName.toLowerCase();
	}

	get subscriptionsLink() {
		if (!this.user) return '';

		return `/author-dashboard/${this.user.authorLink}/subscriptions`;
	}

	get billingLink() {
		if (!this.user) return '';

		return `/author-dashboard/${this.user.authorLink}/billing`;
	}

	getPromoCodeDetails() {
		if (!this.user || this.roleName === 'Free') return;
		this.promoCodeService.getMembershipPromocode(this.user.username)
			.pipe(
				map((result: any) => {
					if (!result.success) {
						throw new Error('Unable to find promo code');
					}

					return result;
				}),
				retry({
					count: 5, // Retry exactly 5 times before failing
					delay: (error, retryCount) => timer(5000),
				}),
			).subscribe(
				(result: any) => {
					if (result.success) {
						this.promoCode = result.promoCode;
						this.renderDiscountUsage();
					}
				},
			);
	}

	renderDiscountUsage() {
		if (this.role === 'free' || !this.promoCode) return;

		const speed = 6;
		const progressBar = <HTMLElement>document.querySelector('.circular-progress');
		const valueContainer = <HTMLElement>document.querySelector('.value-container');
		let progressValue = 0;

		let startGradient = 'rgb(255 144 55)';
		let endGradient = 'rgb(255 174 45)';

		if (this.role === 'platinum') {
			startGradient = '#7a768c';
			endGradient = '#d7d1dd';
		}

		// this.ready = true;

		setTimeout(() => {
			this.currentLimit = this.promoCode.currentLimit;
			this.total = this.promoCode.discountLimit;
			this.available = this.total - this.currentLimit;
			const progress = setInterval(() => {
				if (progressValue === Math.round(this.currentLimit)) {
					clearInterval(progress);
				}
				progressValue += 1;
				valueContainer.textContent = `$${this.available.toFixed(2)}`;
				progressBar.style.background = `conic-gradient(
						${startGradient} 1.8deg,
						${endGradient} ${(progressValue / this.total) * 360}deg,
						#7e959a ${(progressValue / this.total) * 360}deg
					)`;
				if (progressValue === Math.round(this.currentLimit)) {
					clearInterval(progress);
				}
			}, speed);
		}, 200);
	}
}
